module.exports = __webpack_public_path__ + "img/monitor_logo_large_dark.6d0e0464.svg";